export default {
    unsubscribe: {
        invalidLink: 'Invalid unsubscribe link',
        unsubscribeSuccessful: 'You were successfully unsubscribed from email updates.',
    },
};
